import { HttpRequestData, httpUtil } from '@esg/framework';
import { getEnv } from '@esg/shared';

interface GetOverviewCampaignRequest extends HttpRequestData {    
    readonly startTime?: string; 
    readonly endTime?: string;
    readonly branchId?: string;
}

export interface GetOverviewCampaignResponseItem {
    totalOngoing: number;
    totalNotRunning: number;
    totalCompleted: number;
}

export const getOverviewCampaign = httpUtil.createHttpRequestMeta<
    GetOverviewCampaignRequest,
    GetOverviewCampaignResponseItem
>({
    baseUrl: () => getEnv().AGENCY_SERVER,
    path: '/api/v1/campaigns/overview',
    method: 'GET',
    authentication: 'bearer',
});